import {deleteQueryParam, getQueryParam, setQueryParam} from 'src/utils/url';

class Cards {
  constructor() {
    this.priceSelector = '.pc-ProductCard-detailPrice';
    this.reConstructor = this.reConstructor.bind(this);
    this.cardLinkClicked = this.cardLinkClicked.bind(this);
    this.colorsEagerLoadImages = this.colorsEagerLoadImages.bind(this);
    this.colorSwatchIn = this.colorSwatchIn.bind(this);
    this.swatchIn = this.swatchIn.bind(this);
    this.colorsInit = this.colorsInit.bind(this);
    this.isTouchEnabled = StyleBitz.Utils.isTouchEnabled();
    this.isTShirtCategory = this.isTShirtCategory.bind(this);
    this.categoryDefaultQuoteQty = $(`meta[property="category-default-quote-qty"]`).attr('content');
    this.addEvents();
    const $cards = this.cards();
    if (!$cards.length) {
      return;
    }
    this.windowWidth = $(window).width();
    this.reConstructor();
  }

  cards() {
    return $('.pc-ProductCard:not(.pc-ProductCard-BssAwareness)');
  }

  cardLink(card) {
    return card.find('.pc-ProductCard-link');
  }

  cardSwatches(card) {
    if ($('.algolia-listing-pages').length) {
        return;
    }
    if (!(card instanceof jQuery)) {
      card = $(card);
    }
    const filteredColorNames = ProductCatalog.Styles.filteredColorNames();
    const noMinFilter = ProductCatalog.Styles.isFilteredNoMinimum();
    let swatchSelector = '';
    filteredColorNames.forEach(function (colorName, i) {
      if (i > 0) {
        swatchSelector = `${swatchSelector}, `;
      }
      swatchSelector = `${swatchSelector}.pc-Swatch[data-name-${colorName}='1']`;
      if (noMinFilter) {
        return (swatchSelector = `${swatchSelector}[data-no-minimum='1']`);
      }
    });
    return card.find(swatchSelector);
  }

  reConstructor() {
    const $cards = this.cards();
    if (ProductCatalog.IFrame.isFramed()) {
      this.setupKeepShoppingCardLink($cards);
      this.setupMultiItemCardLink($cards);
      this.setupMultiItemYdhImages($cards);
    }
    this.colorsInit($cards);
    this.pricingInit($cards);
    this.quoteQtyInit($cards);
    if (ProductCatalog.ImageLazyLoader !== null) {
      ProductCatalog.ImageLazyLoader.unobserveAll();
      ProductCatalog.ImageLazyLoader.observeAll();
    }
  }

  // Private

  addEvents() {
    $(document).on(
      'mouseenter',
      '.pc-ProductCard .pc-Swatch',
      this.colorSwatchIn
    );
    $(document).on('mouseenter', '.pc-ProductCard', this.colorsEagerLoadImages);
    $(document).on('click', '.pc-ProductCard-link', this.cardLinkClicked);
    $(document).on(
      'click.tooltip',
      '.pc-ProductCard span[data-tooltip]',
      this.tooltipClick
    );
    return $(document).on(
      'mouseenter.tooltip',
      '.pc-ProductCard span[data-tooltip]',
      this.tooltipHover
    );
  }

  // Private (card)

  tooltipClick(e) {
    if ($(window).width() >= 700) {
      return;
    }
    const card = $(e.target).closest('.pc-ProductCard')[0];
    return CustomInk.Metrics.fireEvent(
      'product styles',
      'price icon',
      `${card.dataset.styleName} (#${card.dataset.styleId})`
    );
  }

  tooltipHover(e) {
    if ($(window).width() < 700) {
      return;
    }
    const card = $(e.target).closest('.pc-ProductCard')[0];
    return CustomInk.Metrics.fireEvent(
      'product styles',
      'price icon',
      `${card.dataset.styleName} (#${card.dataset.styleId})`
    );
  }

  toCard(e) {
    const card = $(e.target);
    if (card.is('.pc-ProductCard')) {
      return card;
    }
    return card.closest('.pc-ProductCard');
  }

  cardLinkClicked(e) {
    if ($(window).width() > 700) {
      return;
    }
    const el = $(e.target);
    const isSwatchContainer =
      el.is('.pc-ProductCard-detailSwatches') ||
      el.closest('.pc-ProductCard-detailSwatches').length > 0;
    const isSwatch = el.is('.pc-Swatch') || el.closest('.pc-Swatch').length > 0;
    if (isSwatch) {
      if (el.hasClass('is-selected')) {
        return;
      }
      this.swatchIn(e);
      e.preventDefault();
      return;
    }
  }

  setupKeepShoppingCardLink($cards) {
    if (ProductCatalog.KeepShopping.isEligible()) {
      return $cards.toArray().forEach((card) => {
        const link = this.cardLink($(card));
        let url = setQueryParam(
          'cid',
          ProductCatalog.KeepShopping.compositeId,
          link.attr('href')
        );
        url = setQueryParam('digest', ProductCatalog.KeepShopping.digest, url);
        url = setQueryParam('keep_shopping', 'true', url);
        return link.attr('href', url);
      });
    } else {
      return $cards.toArray().forEach((card) => {
        const link = this.cardLink($(card));
        let url = deleteQueryParam('cid', link.attr('href'));
        url = deleteQueryParam('digest', url);
        url = deleteQueryParam('keep_shopping', url);
        return link.attr('href', url);
      });
    }
  }

  setupMultiItemCardLink($cards) {
    if (ProductCatalog.MultiItem.isEligible()) {
      return $cards.toArray().forEach((card) => {
        const link = this.cardLink($(card));
        const url = ProductCatalog.MultiItem.addMultiItemParamsToUrl(
          link.attr('href')
        );
        return link.attr('href', url);
      });
    } else {
      return $cards.toArray().forEach((card) => {
        const link = this.cardLink($(card));
        let url = deleteQueryParam('cid', link.attr('href'));
        url = deleteQueryParam('digest', url);
        url = deleteQueryParam('multi_item', url);
        return link.attr('href', url);
      });
    }
  }

  setupMultiItemYdhImages($cards) {
    if (
      ProductCatalog.MultiItem.isEligible() &&
      !ProductCatalog.Styles.isFilteredColor()
    ) {
      return $cards.toArray().forEach((card) => {
        const $image = $(card).find('.pc-ProductCard-imagePrimary');
        let srcUrl = $image.data('src');
        srcUrl = ProductCatalog.MultiItem.addMultiItemParamsToUrl(srcUrl);
        srcUrl = setQueryParam('placeUseProduct', 1, srcUrl);
        $image.attr('src', srcUrl);
        $image.data('src', srcUrl);

        let srcSet = $image.data('srcset').split(', ');
        srcSet = srcSet
          .reduce((acc, srcSetUrlSize) => {
            let [url, size] = srcSetUrlSize.split(' ');
            url = ProductCatalog.MultiItem.addMultiItemParamsToUrl(srcUrl);
            url = setQueryParam('placeUseProduct', 1, url);
            acc.push(`${url} ${size}`);
            return acc;
          }, [])
          .join(', ');

        $image.attr('srcset', srcSet);
        $image.data('srcset', srcSet);
      });
    }
  }

  cardSetLinkColor(card, colorSwatch) {
    const colorId = colorSwatch.data('id');
    const link = this.cardLink(card);
    let url = setQueryParam('PK', colorId, link.attr('href'));
    return link.attr('href', url);
  }

  cardSetLinkQuoteQty(card) {
    const link = this.cardLink(card);
    const url = setQueryParam('quote_qty', 'min', link.attr('href'));
    return link.attr('href', url);
  }

  cardSetSwatchSelected(card, swatch, options) {
    if (options == null) {
      options = {};
    }
    if ($('.algolia-listing-pages').length) {
      return;
    }
    if (!options.init) {
      this.cardSwatches(card).removeClass('is-selected');
    }
    return swatch.addClass('is-selected');
  }

  // Private (colors)

  colorsInit($cards) {
    if (
      document.querySelector('.pc-Styles-products.is-filteredColor') == null
    ) {
      return;
    }

    return Array.from($cards.toArray()).map((card) =>
      this.colorsInitCard($(card))
    );
  }

  colorsInitCard(card) {
    if ($('.algolia-listing-pages').length) {
      return;
    }
    const $swatches = this.cardSwatches(card);
    const firstSwatch = $swatches.eq(0);
    const firstSwatchId = firstSwatch.data('id');
    this.colorsImageShow(card, firstSwatchId, true);
    this.cardSetLinkColor(card, firstSwatch);
    return this.cardSetSwatchSelected(card, firstSwatch, {init: true});
  }

  colorsImageShow(card, id, init) {
    if ($('.algolia-listing-pages').length) {
      return;
    }
    const imgs = this.colorsImages(card);
    const img = imgs.filter(`[data-id=${id}]`);
    imgs.not(img).removeClass('is-active');
    this.colorsImageSrc(img);
    img.addClass('is-active');
    return undefined;
  }

  colorsEagerLoadImages(e) {
    if (!$('.pc-Styles').length) {
      return;
    }
    if ($('.algolia-listing-pages').length) {
      return;
    }
    const card = this.toCard(e);
    const imgs = this.colorsImages(card).toArray();
    for (let img of Array.from(imgs)) {
      this.colorsImageSrc($(img));
    }
    return undefined;
  }

  colorsImages(card) {
    if ($('.algolia-listing-pages').length) {
      return;
    }
    const colors = [];
    const colorNames = ProductCatalog.Styles.filteredColorNames();
    const imgColors = card.find('.pc-ProductCard-imageColor');
    for (let color of Array.from(colorNames)) {
      for (let img of Array.from(
        imgColors.filter(`[data-name-${color}]`).toArray()
      )) {
        colors.push(img);
      }
    }
    return $(colors);
  }

  colorsImageSrc(img) {
    // Load the higher DPI src image on mobiles to avoid double image load in Safari
    if ($('.algolia-listing-pages').length) {
      return;
    }
    let src, srcset;
    if (this.windowWidth < 700 && img.length > 0) {
      srcset = img.data('srcset').split(', ');
      if (srcset.length > 1) {
        src = srcset[1].split(' ')[0];
        if (img.attr('src') !== src) {
          img.attr('src', src);
        }
        return;
      }
    }
    if (
      ProductCatalog.KeepShopping.isEligible() ||
      ProductCatalog.MultiItem.isEligible()
    ) {
      const compositeId = getQueryParam('cid');
      const digest = getQueryParam('digest');
      let mmsImagesHostName = 'https://mms-images.out.customink.com';
      if (__ENV__ !== 'production') {
        mmsImagesHostName = 'https://mms-images.staging.customink.com';
      }
      src = `${mmsImagesHostName}/mms/images/catalog/colors/${img.data(
        'id'
      )}/views/alt/front_medium_extended.png?design=${compositeId}&digest=${digest}`;
      if (ProductCatalog.MultiItem.isEligible()) {
        src = `${src}&placeUseProduct=1&placeMaxPct=0.8`;
      }
      if (img.attr('src') !== src) {
        return img.attr('src', src);
      }
    } else {
      const customYDHSettings = window.ydhSettings[img.data("styleId")]
      if (customYDHSettings){
        const color = img.data("id")
        const design =  (customYDHSettings.colors && customYDHSettings.colors[color]?.design) ? customYDHSettings.colors[color]?.design : customYDHSettings?.design
        src = img.data('src');
        src = src.replace("&placeMax=1&placeMaxPct=0.8&placeUseProduct=1&placeUseView=front","")
        if(customYDHSettings.skip_autonegate){
          src = src.replace("autoNegate=1", "autoNegate=0")
        }
        src = src + `&design=${design}`
        srcset = src
      }
      else {
        src = img.data('src');
        srcset = img.data('srcset');
      }
      if (img.attr('src') !== src) {
        img.attr('src', src);
      }
      if (img.attr('srcset') !== srcset) {
        return img.attr('srcset', srcset);
      }
    }
  }

  // Private size availability

  isTShirtCategory() {
    const T_SHIRT_SUBCAT_IDS =
      [16, 17, 18, 19, 91, 104, 112, 197, 198, 246, 247, 354, 399, 403, 460, 505, 714, 849];
    return T_SHIRT_SUBCAT_IDS.includes($('.pc-Styles').data('catid'));
  }

  // Private (swatch)

  colorSwatchIn(e) {
    if ($(window).width() < 700) {
      return;
    }
    return this.swatchIn(e);
  }

  toSwatch(e) {
    const swatch = $(e.target);
    if (swatch.is('.pc-Swatch')) {
      return swatch;
    }
    return swatch.closest('.pc-Swatch');
  }

  swatchIn(e) {
    const card = this.toCard(e);
    const swatch = this.toSwatch(e);
    const id = swatch.data('id');
    this.cardSetLinkColor(card, swatch);
    this.cardSetSwatchSelected(card, swatch);
    this.cardInfoQtySet(card, swatch);
    this.colorsImageShow(card, id);
    return undefined;
  }

  cardInfoQtySet(card, swatch) {
    const qty = swatch.data('min-qty');
    const text = qty === 1 ? 'No Minimum' : `Minimum ${qty}`;
    return this.cardInfoQty(card).text(text);
  }

  cardInfoQty(card) {
    return card.find('.pc-ProductCard-detailQty');
  }

  // Private (pricing)

  pricingInit($cards) {
    if ($('.pc-QuoteControl-form-input').val()) {
      ProductCatalog.Pricing.fetchOrdQtyPricing();
    } else if (ProductCatalog.IFrame.isFramed()) {
      $(this.priceSelector).css({display: 'none'});
    } else {
      const catId = ProductCatalog.Pricing.defaultQuoteCategory();
      for (let card of Array.from($cards.toArray())) {
        this.pricingSetupForCategory(card, catId);
      }
    }
    return undefined;
  }

  pricingSetupForCategory(card, catId) {
    const priceArea = card.querySelector(this.priceSelector);
    let priceData = null;
    const geolocationAlgorithm = ProductCatalog.Pricing.defaultAlgorithm;
    if (catId) {
      let priceDataSelector = `.pc-ProductCard-detailPriceData` +
        `.pc-ProductCard-detailPriceData` +
          `[data-id='${catId}']` +
          `[data-algorithm='${geolocationAlgorithm}']` +
          `[data-quantity='${this.categoryDefaultQuoteQty}']`;
      priceData = card.querySelector(priceDataSelector);
    } else if ($('.pc-Styles-products').is('.is-Custom')) {
      priceData = card.querySelector(
        '.pc-ProductCard-detailPriceData--primary'
      );
    }
    if (priceData) {
      const html = priceData.getAttribute('data-display');
      if (!html) {
        return undefined;
      } else {
        priceArea.innerHTML = html;
        priceArea.insertAdjacentHTML(
          'beforeend',
          '<span class="pc-ProductCard-detailPriceInfo"' +
            ' data-tooltip="#default_quote_tooltip"></span>'
        );
      }
      priceArea.style.visibility = 'visible';
    }
    return undefined;
  }

  // Private (quote qty links)

  quoteQtyInit($cards) {
    if (getQueryParam('min_qty[]') !== '1') {
      return;
    }
    return Array.from($cards.toArray()).map((card) =>
      this.cardSetLinkQuoteQty($(card))
    );
  }
}

jQuery(() => (ProductCatalog.Cards = new Cards()));
